import httpRequest from "../utils/requests";
// 考试ID
const tRAIN_ID = 6;

const api = {
  getQuestionPaperInfoH5Vo:
    "/education-web-api/trainWeb/class/getQuestionPaperInfoH5Vo",
  answerQuestion: "/education-web-api/trainWeb/class/answerQuestion",
  handPaper: "/education-web-api/trainWeb/class/handPaper",
  login: "/education-web-api/member-web/member/loginByNameAndCardAndMemberCode",
};
// 登录
// export const login = (params) => {
//   return httpRequest.post(api.login, params);
// };
// 单题答题
export const answerQuestion = (params) => {
  return httpRequest.post(api.answerQuestion, params);
};
// 提交
export const handPaper = (params) => {
  return httpRequest.post(api.handPaper, params);
};
// 获取试卷
export const getQuestionPaperInfoH5Vo = () => {
  return httpRequest.get(api.getQuestionPaperInfoH5Vo, { trainId: tRAIN_ID });
};

// 登录
export const login = (query) => {
  return httpRequest.post(`/node/login`, query);
};
// 获取试卷
export const examPaperGet = (params) => {
  return httpRequest.get(`/node/getPaper`, { params });
};
export const examPaperSet = (query) => {
  return httpRequest.post(`/node/setPaper`, query);
}; 
export const examAnswerGet = (params) => {
  return httpRequest.get(`/node/getAnswer`, { params });
};
export const examAnswerSet = (query) => {
  return httpRequest.post(`/node/setAnswer`, query);
};

export const examGet = () => {
  return httpRequest.get(`/node/getExam`);
};

export const nodeCheck = () => {
  return httpRequest.get(`/node/nodeCheck`);
};
